import React from "react";
import { useParams, Link } from "react-router-dom";

const CleaningPurchaseSuccess = () => {
  const { listingId } = useParams();

  return (
    <div style={{ textAlign: "center", marginTop: 120, padding: "0 20px" }}>
      <h1 style={{ color: "#0b6b2d" }}>✅ Cleaning Purchase Successful</h1>

      <p>
        Your payment has been confirmed for cleaning listing{" "}
        <strong>{listingId}</strong>.
      </p>

      <p>
        We’re finalising the sale details. You’ll see this in your dashboard
        shortly.
      </p>

      {/* WHAT HAPPENS NEXT */}
      <div
        style={{
          marginTop: "30px",
          padding: "18px",
          backgroundColor: "#f1f8e9",
          border: "1px solid #c5e1a5",
          borderRadius: "8px",
          maxWidth: "700px",
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "left",
        }}
      >
        <h3 style={{ marginTop: 0, color: "#2e7d32" }}>
          What happens next?
        </h3>

        <ul style={{ margin: "10px 0 0 18px", lineHeight: "1.6" }}>
          <li>
            A confirmation email will be sent to you shortly with further
            instructions.
          </li>
          <li>
            The buyer and seller can then contact each other directly to arrange
            the client handover.
          </li>
          <li>
            The listing has been marked as <strong>sold</strong> and is no longer
            visible to other buyers.
          </li>
          <li>
            Funds are released to the seller{" "}
            <strong>after handover is confirmed</strong> within the Client
            Exchange system.
          </li>
          <li>
            Client Exchange does not manage ongoing payments, scheduling, or
            service delivery after handover.
          </li>
        </ul>
      </div>

      <div style={{ marginTop: 40 }}>
        <Link
          to="/dashboard"
          style={{
            padding: "12px 22px",
            background: "#0b6b2d",
            color: "white",
            textDecoration: "none",
            borderRadius: "6px",
            marginRight: "12px",
          }}
        >
          Go to Dashboard
        </Link>

        <Link
          to={`/cleaning/listing/${listingId}`}
          style={{
            padding: "12px 22px",
            background: "#333",
            color: "white",
            textDecoration: "none",
            borderRadius: "6px",
          }}
        >
          View Listing
        </Link>
      </div>
    </div>
  );
};

export default CleaningPurchaseSuccess;
